import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

import { Footer } from "./footer";
import { Header } from "./header";
import { SubHeader } from "./subHeader";
import { GlobalSpacing } from "./styles";
import { useGlobalContext } from "../../provider";

interface LayoutProps {
	children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
	const [globalState, { dispatch }]: GlobalContextType = useGlobalContext();

	const handleCloseNotification = () => {
		const newData = { ...globalState.notification, open: false }
		dispatch({ notification: newData })
	}

	return (
		<LayoutWrapper>
			<HeaderContainer>
				<Header />
			</HeaderContainer>

			<ContentContainer>
				{globalState.notification.open && (
					<NotificationWrapper bg={globalState.notification.bg} textColor={globalState.notification.textColor}>
						<NotificationContent>
							<Typography variant="h6">
								{globalState.notification.message}
							</Typography>

							<CloseIconContainer onClick={handleCloseNotification}>
								<CloseIcon fontSize="small" />
							</CloseIconContainer>
						</NotificationContent>
					</NotificationWrapper>
				)}

				<SubHeader />

				{children}
			</ContentContainer>

			<Footer />
		</LayoutWrapper>
	)
}

const LayoutWrapper = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",

	height: "100vh",
	overflowY: "auto",
	overflowX: "hidden",
}))

const HeaderContainer = styled(Box)({
	top: 0,
	position: "sticky",

	zIndex: 2,
	display: "flex",
	flexDirection: "column",
})

const ContentContainer = styled(Box)({
	zIndex: 1,
	display: "flex",
	flexDirection: "column",
})

const NotificationWrapper = styled(GlobalSpacing)<{ bg: string, textColor: string }>(({ bg, textColor }) => ({
	backgroundColor: bg,

	"h1, h2, h3, h4, h5, h6, p, span, a": {
		color: textColor,
		fontWeight: 500,
	},
}))

const NotificationContent = styled(Box)({
	position: "relative",

	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	justifyContent: "center",

	height: 50,
})

const CloseIconContainer = styled(Box)({
	position: "absolute",
	right: -10,
	top: 5,

	display: "flex",
	alignItems: "center",
	justifyContent: "center",

	cursor: "pointer",
})

export { Layout }